import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const Role = types.compose(
  BaseEntity,
  types
    .model('Role', {
      roleId: types.identifierNumber,
      name: types.string,
    })
    .actions((self) => {
      const setName = (name: string) => {
        self.name = name;
      };
      const getName = () => {
        return self.name;
      };
      return {
        setName,
        getName,
      };
    }),
);
